import Vue from 'vue';
import Vuex from 'vuex';
import axios from '../http';
import { Message } from 'element-ui';
import ga from '../utils/google-analyze.js';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    rcode: sessionStorage['rcode'] ? sessionStorage['rcode'] : 'hk',
    ccode: sessionStorage['ccode'] ? sessionStorage['ccode'] : 'HKD',
    language: sessionStorage['language'] ? sessionStorage['language'] : 'en',
    isRegisterShow: false,
    isForgotShow: false,
    isLoginShow: false,
    isCartShow: false,
    actTab: 'Index',
    isPC: $(document.body).width() >= 992 ? true : false,
    minHeight: ($(window).height() - 140) + 'px',
    token: '',
    token_type: '',
    user: {
      id: '',
      name: '',
      email: '',
      is_newsletter: '',
      language: '',
    },
    cartList: sessionStorage['cartList'] ? JSON.parse(
      sessionStorage['cartList']) : [],
    totalPrice: 0,
    totalAmount: 0,
    address: {
      region: '',
      receiver: '',
      company: '',
      address_line1: '',
      address_line2: '',
      phone: '',
      email: '',
    },
    couponCode: {
      code: '',
      type: '',
      codeVal: 0,
      min_amount: 0,
      totalPrice: 0,
    },
    remark: '',
    animal: sessionStorage['animal'] ? JSON.parse(sessionStorage['animal']) : {
      index: 0,
      id: '',
      title: '',
      sum: 0,
    },
    animalBg: sessionStorage['animalBg'] ? sessionStorage['animalBg'] : '',
    animalListShow: false,
  },
  getters: {
    cartList (state) {
      if (!state.token) {
        sessionStorage.setItem('cartList', JSON.stringify(state.cartList));
      }
      return state.cartList;
    },
    totalPrice (state) {
      let sum = 0;
      if (state.cartList == [] || state.cartList == undefined) {
      } else {
        state.cartList.forEach((item) => {

          // if(item.shop_product_sku.sales_price!=item.shop_product_sku.price){
          if (item.shop_product_sku.shop_product.sales) {
            sum += item.amount * item.shop_product_sku.sales_price;
          } else {
            sum += item.amount * item.shop_product_sku.price;
          }
        });
      }
      sum = Math.floor(parseFloat(sum * 100)) / 100;
      sum = sum.toFixed(2);
      return state.totalPrice = sum;
    },
    totalAmount (state) {
      let sum = 0;
      if (state.cartList == [] || state.cartList == undefined) {
      } else {
        state.cartList.forEach((item) => {
          sum += item.amount;
        });
      }
      return state.totalAmount = sum;
    },
  },
  mutations: {
    refreshToken (state) {
      axios({
        method: 'PUT',
        url: '/api/authorizations/current',
        headers: {
          'Authorization': localStorage.token_type + localStorage.token,
        },
      }).then(res => {
        console.log('refreshToken');
        localStorage.setItem('token', res.access_token);
        this.commit('setToken', res.access_token);
        window.location.reload();
      }).catch(error => {
        console.log('no storeToken');
        localStorage.clear();
        this.commit('resetUser');
        this.commit('resetCartList');
        setTimeout(function () {
          state.isLoginShow = true;
        }, 1000);
      });
    },
    // 地区
    changeRegionCode (state, val) {
      state.rcode = val.rcode;
      state.ccode = val.ccode;
    },
    // 页面语言
    changeLanguage (state, val) {
      state.language = val;
    },
    // 控制弹窗
    changeRegisterShow (state, val) {
      state.isRegisterShow = val;
    },
    // 控制弹窗
    changeForgotShow (state, val) {
      state.isForgotShow = val;
    },
    // 控制弹窗
    changeLoginShow (state, val) {
      state.isLoginShow = val;
    },
    // 控制弹窗
    changeCartShow (state, val) {
      state.isCartShow = val;
    },
    setToken (state, val) {
      state.token = val;
      this.commit('getCartList');
    },
    setTokenType (state, val) {
      state.token_type = val;
    },
    setUserId (state, val) {
      state.user.id = val;
    },
    setUserName (state, val) {

      if (val.includes(' ')) {
        state.user.name = val.split(' ')[1];
      } else {
        state.user.name = val;
      }
    },
    setUserEmail (state, val) {
      state.user.email = val;
    },
    setNewsletter (state, val) {
      state.user.is_newsletter = val;
      localStorage.setItem('is_newsletter', val);
    },
    setLanguage (state, val) {
      state.user.language = val;
    },
    // 重置用户信息
    resetUser (state) {
      state.user = {
        id: '',
        name: '',
        email: '',
        is_newsletter: '',
        language: '',
      };
      state.token = '';
      state.token_type = '';
    },
    // 设置active头部
    setActTab (state, val) {
      state.actTab = val;
      sessionStorage.setItem('actTab', val);
    },
    setIsPC (state, val) {
      state.isPC = val;
    },
    setMinHeight (state, val) {
      state.minHeight = val;
    },
    // 加入购物车
    addToCart (state, val) {
      if (state.token) {
        let amount = val.amount ? val.amount : 1;
        // console.log(amount,val.id);
        axios({
          method: 'POST',
          url: '/api/carts',
          headers: {
            'Authorization': localStorage.token_type + localStorage.token,
          },
          data: {
            // shop_product_id:val.id,
            // amount:amount,
            shop_product_sku_id: val.id,
            amount,
          },
        }).then(res => {
          console.log('---------', res);
          if (res.status_code == 201) {
            if (state.language == 'zh-CN') {
              var messageInfo = '添加到购物车成功！';
            } else if (state.language == 'zh-TW') {
              var messageInfo = '添加到購物車成功！';
            } else {
              var messageInfo = 'Add to Cart successful!';
            }
            Message({
              message: messageInfo,
              type: 'success',
              duration: 1500,
              offset: 200,
            });
          }
          ga.event('product', 'click', 'addToCart');
          fbq('track', 'AddToCart', {
            currency: state.ccode,
            content_type: 'addToCart',
            contents: [{ id: val.id, quantity: amount }],
          });
          this.commit('getCartList');
        }).catch(err => {

        });
      } else {
        let amount = val.amount ? val.amount : 1;
        let newGood = {
          // shop_product_id: val.id,
          // amount: amount,
          // shop_product: {
          //     id: val.id,
          //     image_url: val.image_url,
          //     title: val.title,
          //     // description: val.description,
          //     price: val.price,
          //     sales_price: val.sales_price,
          // },
          shop_product_sku_id: val.id,
          amount: amount,
          shop_product_sku: {
            id: val.id,
            shop_product: { sales: val.shop_product.sales },
            price: val.price,
            sales_price: val.sales_price,
            shop_product_id: val.shop_product_id,
            sku_image: val.sku_image,
            sku_image_url: val.sku_image_url,
            sku_outer_id: val.sku_outer_id,
            stock: val.stock,
            title: val.title,
          },
        };
        let index = -1;
        index = state.cartList.findIndex(item => {
          // return item.shop_product_id==val.id;
          return item.shop_product_sku_id == val.id;
        });
        if (index == -1) {
          state.cartList.push(newGood);
        } else {
          state.cartList[index].amount += amount;
        }
        if (state.language == 'zh-CN') {
          var messageInfo = '添加到购物车成功！';
        } else if (state.language == 'zh-TW') {
          var messageInfo = '添加到購物車成功！';
        } else {
          var messageInfo = 'Add to Cart successful!';
        }
        Message({
          message: messageInfo,
          type: 'success',
          duration: 1500,
          offset: 200,
        });
        if (state.couponCode.code) {
          this.commit('getCouponCodes');
        } else {
          state.couponCode = {
            code: '',
            type: '',
            codeVal: '',
            min_amount: 0,
            totalPrice: 0,
          };
        }
        ga.event('product', 'click', 'addToCart');
        fbq('track', 'AddToCart', {
          currency: state.ccode,
          content_type: 'addToCart',
          contents: [{ id: val.id, quantity: amount }],
        });
      }
    },
    // 增删购物车
    changeNum (state, data) {
      console.log(data);
      if (state.token) {
        if (data.num > data.old) {
          //增加
          axios({
            method: 'POST',
            url: '/api/carts',
            headers: {
              'Authorization': localStorage.token_type + localStorage.token,
            },
            data: {
              // shop_product_id:state.cartList[data.index].shop_product_id,
              shop_product_sku_id: state.cartList[data.index].shop_product_sku_id,
              amount: (data.num - data.old),
            },
          }).then(res => {
            if (res.status_code == 201) {
              if (state.language == 'zh-CN') {
                var messageInfo = '添加到购物车成功！';
              } else if (state.language == 'zh-TW') {
                var messageInfo = '添加到購物車成功！';
              } else {
                var messageInfo = 'Add to Cart successful!';
              }
              Message({
                // message: res.message,
                message: messageInfo,
                type: 'success',
                duration: 1500,
                offset: 200,
              });
            }

            ga.event('shopcart', 'click', 'increaseQty');
            fbq('track', 'AddToCart', {
              currency: state.ccode,
              content_type: 'increaseQty',
              contents: [{ id: state.cartList[data.index].shop_product_sku_id }],
            });
            this.commit('getCartList');
          }).catch(error => {

          });
        } else {
          //减少
          axios({
            method: 'PATCH',
            url: '/api/carts',
            headers: {
              'Authorization': localStorage.token_type + localStorage.token,
            },
            data: {
              // shop_product_id:state.cartList[data.index].shop_product_id,
              shop_product_sku_id: state.cartList[data.index].shop_product_sku_id,
              amount: data.old - data.num,
            },
          }).then(res => {
            if (res.status_code == 201) {
              if (state.language == 'zh-CN') {
                var messageInfo = '减少购物车的成功！';
              } else if (state.language == 'zh-TW') {
                var messageInfo = '減少購物車的成功！';
              } else {
                var messageInfo = 'Reduce shopping cart success!';
              }
              Message({
                // message: res.message,
                message: messageInfo,
                type: 'success',
                duration: 1500,
                offset: 200,
              });
            }
            ga.event('shopcart', 'click', 'reduceQty');
            fbq('track', 'AddToCart', {
              currency: state.ccode,
              content_type: 'reduceQty',
              contents: [{ id: state.cartList[data.index].shop_product_sku_id }],
            });
            this.commit('getCartList');
          }).catch(error => {

          });
        }
      } else {
        state.cartList[data.index].amount = data.num;
        if (state.language == 'zh-CN') {
          var messageInfo = '已成功修改！';
        } else if (state.language == 'zh-TW') {
          var messageInfo = '已成功修改！';
        } else {
          var messageInfo = 'Successfully modified!';
        }
        Message({
          message: messageInfo,
          type: 'success',
          duration: 1500,
          offset: 200,
        });
        if (state.couponCode.code) {
          this.commit('getCouponCodes');
        } else {
          state.couponCode = {
            code: '',
            type: '',
            codeVal: '',
            min_amount: 0,
            totalPrice: 0,
          };
        }
        ga.event('shopcart', 'click', 'editQty');
        fbq('track', 'AddToCart', {
          currency: state.ccode,
          content_type: 'editQty',
          contents: [{ id: state.cartList[data.index].shop_product_sku_id }],
        });
      }
    },
    // 移除购物车
    removeCart (state, index) {
      if (state.token) {
        axios({
          method: 'DELETE',
          url: '/api/carts',
          headers: {
            'Authorization': localStorage.token_type + localStorage.token,
          },
          data: {
            // shop_product_id:state.cartList[index].shop_product_id
            shop_product_sku_id: state.cartList[index].shop_product_sku_id,
          },
        }).then(res => {
          if (state.language == 'zh-CN') {
            var messageInfo = '删除成功！';
          } else if (state.language == 'zh-TW') {
            var messageInfo = '刪除成功！';
          } else {
            var messageInfo = 'Successfully removed!';
          }
          Message({
            message: messageInfo,
            type: 'success',
            duration: 1500,
            offset: 200,
          });
          ga.event('shopcart', 'click', 'remove');
          fbq('track', 'AddToCart', {
            currency: state.ccode,
            content_type: 'remove',
            contents: [{ id: state.cartList[index].shop_product_id }],
          });
          this.commit('getCartList');
        }).catch(error => {

        });
      } else {
        state.cartList.splice(index, 1);
        if (state.language == 'zh-CN') {
          var messageInfo = '删除成功！';
        } else if (state.language == 'zh-TW') {
          var messageInfo = '刪除成功！';
        } else {
          var messageInfo = 'Successfully removed!';
        }
        Message({
          message: messageInfo,
          type: 'success',
          duration: 1500,
          offset: 200,
        });
        if (state.couponCode.code) {
          this.commit('getCouponCodes');
        } else {
          state.couponCode = {
            code: '',
            type: '',
            codeVal: '',
            min_amount: 0,
            totalPrice: 0,
          };
        }
        ga.event('shopcart', 'click', 'remove');
        fbq('track', 'AddToCart', {
          currency: state.ccode,
          content_type: 'remove',
          contents: [{ id: state.cartList[index].shop_product_id }],
        });
      }
    },
    // 获取购物车列表
    getCartList (state) {
      axios({
        method: 'GET',
        url: '/api/carts',
        headers: {
          'Authorization': localStorage.token_type + localStorage.token,
        },
      }).then(res => {
        console.log(res.cart_items);
        state.cartList = res.cart_items;
        if (state.couponCode.code) {
          this.commit('getCouponCodes');
        } else {
          state.couponCode = {
            code: '',
            type: '',
            codeVal: '',
            min_amount: 0,
            totalPrice: 0,
          };
        }
      }).catch(error => {

      });
    },
    //合并购物车
    mergeCart (state) {
      console.log(state.cartList);
      if (state.cartList.length > 0) {
        let data = [];
        state.cartList.forEach(item => {
          let temp = {
            // shop_product_id:item.shop_product_id,
            shop_product_sku_id: item.shop_product_sku_id,
            amount: item.amount,
          };
          data.push(temp);
        });
        console.log(data);
        axios({
          method: 'POST',
          url: '/api/carts/cookie',
          headers: {
            'Authorization': localStorage.token_type + localStorage.token,
          },
          data: {
            items: JSON.stringify(data),
          },
        }).then(res => {
          sessionStorage.removeItem('cartList');
          this.commit('getCartList');
        }).catch(error => {

        });
      }
    },
    // 清空购物车
    resetCartList (state) {
      state.cartList = [];
    },
    // 结算购物车的优惠券
    setCode (state, val) {
      state.couponCode.code = val;
    },
    getCouponCodes (state, val) {
      axios({
        method: 'GET',
        url: '/api/coupon_codes/' + val,
        headers: {
          'Authorization': localStorage.token_type + localStorage.token,
        },
      }).then(res => {
        console.log(res);
        state.couponCode.code = val;
        state.couponCode.type = res.type;
        state.couponCode.min_amount = res.min_amount;

        if (state.totalPrice > (res.min_amount * 100 / 100)) {
          if (res.type == 'percent') {
            state.couponCode.codeVal = state.totalPrice * (res.value / 100);
            state.couponCode.totalPrice = state.totalPrice -
              state.couponCode.codeVal;
          } else if (res.type == 'fixed') {
            state.couponCode.codeVal = res.value;
            state.couponCode.totalPrice = state.totalPrice -
              state.couponCode.codeVal;
          }
          ga.event('shopcart', 'submit', 'couponCode');
          fbq('track', 'couponCode', { content_ids: val });
        } else {
          state.couponCode = {
            code: '',
            type: '',
            codeVal: '',
            min_amount: 0,
            totalPrice: 0,
          };
          if (state.language == 'zh-CN') {
            var messageInfo = '订单总价少于';
          } else if (state.language == 'zh-TW') {
            var messageInfo = '訂單總價少於';
          } else {
            var messageInfo = 'The total order price is less than ' +
              state.ccode;
          }
          Message({
            message: messageInfo + ' ' + res.min_amount,
            type: 'error',
            duration: 1500,
            offset: 200,
          });
        }

      }).catch(error => {
        state.couponCode = {
          code: '',
          type: '',
          codeVal: '',
          min_amount: 0,
          totalPrice: 0,
        };
        if (state.language == 'zh-CN') {
          var messageInfo = '优惠券无效！';
        } else if (state.language == 'zh-TW') {
          var messageInfo = '優惠券無效！';
        } else {
          var messageInfo = 'Coupon is invalid!';
        }
        Message({
          message: messageInfo,
          type: 'error',
          duration: 1800,
          offset: 200,
        });
      });
    },
    // 结算购物车的备注
    setRemark (state, val) {
      state.remark = val;
    },
    // 结算购物车的收获地址
    setAddress (state, val) {
      let addressInfo = {
        region: val.region,
        receiver: val.receiver,
        company: val.company,
        address_line1: val.address_line1,
        address_line2: val.address_line2,
        phone: val.phone,
        email: val.email,
      };
      state.address = addressInfo;
    },
    setAnimal (state, val) {
      let animalInfo = {
        index: val.index,
        id: val.id,
        title: val.title,
        sum: val.sum,
      };
      sessionStorage.setItem('animal', JSON.stringify(animalInfo));
      state.animal = animalInfo;
    },
    setAnimalBg (state, val) {
      sessionStorage.setItem('animalBg', val);
      state.animalBg = val;
    },
    setAnimalShow (state, val) {
      state.animalListShow = val;
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js